import type { AccountSectionCardType } from '@/shared/types';

export const pendingCardsComparator = (
  a: AccountSectionCardType,
  b: AccountSectionCardType
): number => {
  if (a.isPending === b.isPending) {
    return 0;
  }

  // Non-pending cards come first
  // Pending cards come last
  return a.isPending ? 1 : -1;
};
